module.exports = "/images/loading.svg?29b22df1026363e7f32d83fead96e715";